import { PictureSources } from 'features/reviews';
import React from 'react';
import { Styles as TLStyles } from 'common/components/media-gallery/tiles-line-gallery.styles';
import { ImagePlaceholder } from '@navi-toolbox/ui-components';
import { Styles } from '../styles';
import { useTranslation } from 'react-i18next';

export const TileContent: React.FC<{
  picture: PictureSources;
  onShowPicture: (pic: PictureSources | null) => void;
}> = ({ picture, onShowPicture }) => {
  const { t } = useTranslation();
  let { urlThumb: src } = picture;
  return (
    <button
      className={Styles.showReviewPhotoBtn}
      onClick={() => onShowPicture(picture)}
      data-qa="photo-thumb-at-review_mf-pdp"
    >
      <ImagePlaceholder
        className={TLStyles.tileImgTileContent}
        src={src}
        loading="lazy"
        alt=""
        fallbackWidth={48}
        fallbackHeight={48}
        fallbackAlt={t('ui.image.alt')}
      />
    </button>
  );
};
